<template>
  <v-app>
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- If using vue-router -->
      <router-view></router-view>
    </v-main>

    <v-footer height="70">
      <v-row
        justify="center"
        align="center"
        class="title font-weight-light grey--text text--lighten-1"
      >
        {{appName}} —
        <span
          class="subtitle-2 font-weight-light ml-1"
        >&copy; {{ (new Date()).getFullYear() }} Copyright GroupBot</span>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { apiClient } from "@/api";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  data: () => ({}),
  computed: {
    ...mapState("app", ["appName"]),
    ...mapGetters("apiAuth", ["user"]),
    ...mapGetters("app", ["selectedBot"]),
    ...mapGetters("config", ["botApiUrl"]),
    bots() {
      return this.user && this.user.account && this.user.account.bots;
    },
    apiKey() {
      return this.$route.params.key;
    },
    botId() {
      return this.$route.params.bot;
    },
    /*botApiUrl() {
      return localStorage.getItem("botApiUrl");
    },*/
  },
  methods: {
    ...mapActions("apiAuth", {
      authenticateApi: "authenticate",
      apiLogout: "logout",
    }),
    ...mapActions("botAuth", {
      authenticateBot: "authenticate",
      botLogout: "logout",
    }),
    ...mapActions("app", ["showMessage", "removeMessage", "selectedBotSet"]),
    ...mapActions("config", ["apiUrlSet", "apiUrlRemove"]),
    voidFn() {},
    closeNotify(fn) {
      if (typeof fn === 'function') {
        fn();
      }
      this.removeMessage();
    },
    async setBot() {
      let bot;

      if (this.botApiUrl && this.bots && this.bots.length) {
        bot = this.bots.find(
          (bot) =>
            (bot.app_url === this.botApiUrl || bot.api_url === this.botApiUrl)
        );
      } else if (!this.botApiUrl && this.bots && this.bots.length) {
        bot = this.bots.find(
          (bot) =>
            bot.active
        );
        this.apiUrlSet(bot.app_url || bot.api_url);
      } else if (this.botId) {
        bot = await this.$store.dispatch("bots/get", this.botId);
        this.apiUrlSet(bot.app_url || bot.api_url);
      }

      if (bot) this.selectedBotSet(bot);
    },
    async authenticationEvents(message) {
      switch (message.event) {
        case "logged-in":
          console.log("Logged in...");
          this.setBot();
          setTimeout(() => {
            location.href = "/app/dashboard";
          }, 1000);
          break;
        case "logged-out":
          console.log("Logged out...");
          if (this.botApiUrl) {
            this.apiUrlRemove();
            setTimeout(() => {
              location.href = "/login";
            }, 1000);
          }
          break;
        case "session-expired":
          console.log("Session expired...");
          await this.apiLogout();
          await this.botLogout();
          apiClient.emit("authentication", { event: "logged-out" });
          break;
      }
    },
  },
  watch: {
    bots(botsNow, botsBefore) {
      if (botsNow && botsNow !== botsBefore) this.setBot();
    },
  },
  async mounted() {},
  async created() {
    this.$vuetify.theme.dark = true;

    if (this.$router.currentRoute.hash) {
      this.$vuetify.goTo(this.$router.currentRoute.hash);
    }

    this.$router.onReady(async () => {
      try {
        await this.authenticateApi();
      } catch (error) {
        console.log("API not authenticated...", error, this.$route.params);

        if (this.apiKey) {
          await this.authenticateApi({ strategy: 'api-key', api_key: this.apiKey });
          this.setBot();
        }
      }
      try {
        await this.authenticateBot();
      } catch (error) {
        console.log("Bot not authenticated...", error);
      }
    });

    // Listen for authhentication events
    apiClient.on("authentication", this.authenticationEvents);
  },
};
</script>

<style lang="scss">
.theme--light {
  ::-webkit-scrollbar {
    width: 15px;
  }

  ::-webkit-scrollbar-track {
    background: #e6e6e6;
    border-left: 1px solid #dadada;
  }

  ::-webkit-scrollbar-thumb {
    background: #b0b0b0;
    border: solid 3px #e6e6e6;
    border-radius: 7px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: black;
  }
}

.theme--dark {
  ::-webkit-scrollbar {
    width: 15px;
  }

  ::-webkit-scrollbar-track {
    background: #202020;
    border-left: 1px solid #2c2c2c;
  }

  ::-webkit-scrollbar-thumb {
    background: #3e3e3e;
    border: solid 3px #202020;
    border-radius: 7px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: white;
  }
}
</style>